import { Icon } from '@iconify/react/dist/iconify.js'
import React, { useRef } from 'react'

const UploadCSVFileList = () => {
    const fileInputRef = useRef(null);

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        const csvFiles = files.filter(file => file.name.endsWith('.csv'));

        // You can handle parsing or further logic here

    };

    const triggerFileInput = () => {
        fileInputRef.current.click();
    };

    return (
        <div>
            <button
                type="button"
                className="btn d-inline-flex align-items-center gap-2"
                onClick={triggerFileInput}
            >
                <Icon icon="solar:upload-linear" className="text-xl" />
                Import
            </button>
            <input
                type="file"
                ref={fileInputRef}
                accept=".csv"
                multiple
                hidden
                onChange={handleFileChange}
            />
        </div>
    );
};

export default UploadCSVFileList;
